
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mllipisidbrtyjfapbre.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1sbGlwaXNpZGJydHlqZmFwYnJlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc4OTgyMjYsImV4cCI6MjA1MzQ3NDIyNn0.7Jb3UGMUEq-Pgf7xkrBpvmqDtuzifqjRCN1obhp6PF8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Initialize payment-photos bucket if it doesn't exist
(async () => {
  try {
    // Check if the bucket exists
    const { data: buckets } = await supabase.storage.listBuckets();
    
    if (!buckets?.find(bucket => bucket.name === 'payment-photos')) {
      // Create the bucket if it doesn't exist
      await supabase.storage.createBucket('payment-photos', {
        public: true // Make the bucket public so we can access files directly
      });
      console.log('Created payment-photos bucket');
    }
  } catch (error) {
    console.error('Error checking/creating payment-photos bucket:', error);
  }
})();
